<template>
  <div>
  </div>
</template>

<script>
import {useConfigStore} from "@/stores/config";
import CoreService from "@/services/core.service";
import { dayjs } from "@/main";
import ConversationService from "@/services/conversation.service";

import DomUtil from "@/utils/dom.util";

let configStore = null

export default {
  name: "RpcCalls",
  props: [],
  methods: {
    /**
     * External function to be called remotely (from embed.js)
     */
    pushView(name, params) {
      CoreService.push(name, params)
    },
    replaceView(name, params) {
      CoreService.replace(name, params)
    },
    setFullScreenMode(enabled) {
      configStore.setFullScreenMode(enabled)
    },
    setMessengerMode(mode) {
      configStore.setMessengerMode(mode)
    },
    setTheme(theme) {
      configStore.setTheme(theme)
    },
    setDayJSLocale(locale) {
      dayjs.locale(locale)
      CoreService.refresh();

    },
    setFrameVisibility(bool) {
      configStore.setFrameVisibility(bool)
    },
    openConversation(params) {
      return ConversationService.openLastOrStartNewConversation(params)
    },
    async sendMessage(id, text) {
      DomUtil.enableSmoothConversationScrolling(true)
      await ConversationService.addOutboundMessage(id, text)
      DomUtil.enableSmoothConversationScrolling(false)
    }
  },
  mounted() {
    configStore = useConfigStore()
  }
}
</script>

<style scoped>

</style>